'use client'

import React, { useEffect, useRef, useState } from 'react'
import { RotateCcwIcon, Search } from 'lucide-react'

import { RevealSection, RevealUl } from '@/components/RevealSection'
import { TabSelect } from '@/components/TabSelect'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useWinsContext, winsScopeTabs } from '@/providers/WinsProvider'

import FilterButton from './components/FilterButton'

const Filter = () => {
  const {
    winTopics,
    searchTerm,
    setSearchTerm,
    selectedTopics,
    toggleTopic,
    clearTopics,
    selectedScopeTab,
    setSelectedScopeTab,
  } = useWinsContext()
  const searchInputRef = useRef<HTMLInputElement>(null)

  // Local search term for immediate UI feedback (debouncing handled in provider)
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm)

  // Sync local search term to context (provider handles debouncing for API calls)
  useEffect(() => {
    setSearchTerm(localSearchTerm)
  }, [localSearchTerm, setSearchTerm])

  return (
    <RevealSection stagger className="flex w-full shrink-0 flex-col gap-4">
      <Input
        ref={searchInputRef}
        placeholder="Search"
        IconComponent={Search}
        className="w-full items-center"
        value={localSearchTerm}
        onChange={(e) => setLocalSearchTerm(e.target.value)}
        onClear={() => setLocalSearchTerm('')}
      />
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-family-body text-base font-semibold text-muted-foreground">Filters</h3>
        <Button
          variant="iconOutline"
          size="small"
          customIcon={<RotateCcwIcon className="size-4.5" />}
          title="Clear filters"
          onClick={clearTopics}
          disabled={selectedTopics.length === 0}
        />
      </div>
      <TabSelect
        tabs={winsScopeTabs}
        value={selectedScopeTab}
        onTabChange={(value) => {
          setSelectedScopeTab(value as (typeof winsScopeTabs)[number]['value'])
        }}
      />
      <RevealUl stagger className="flex flex-col gap-2">
        {winTopics.map((topic) => (
          <div key={topic.id} className="w-full">
            <FilterButton
              topic={topic}
              handleTopicClick={toggleTopic}
              activeTopics={selectedTopics}
            />
          </div>
        ))}
      </RevealUl>
    </RevealSection>
  )
}

export default Filter
